<div id="main-mobile-app-wrapper" class="full-height">
  <router-outlet></router-outlet>
</div>


<div id="main-wrapper-landscape-message">
  <lib-amdocs-landscape-view></lib-amdocs-landscape-view>
</div>
